// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__iPMMc","img":"Hero_img__PWYWA","caption":"Hero_caption__UtLDQ"};